import React, { Component } from 'react';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import format from '../../shared/format';
import { getMatchOption } from '../../shared/selectFn';

class ApplyJdeCodeInfo extends Component {
    state = {
        options: [],
        fileList: [],
    }

    componentDidMount() {
        this.configOptions();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.configOptions();
        }
    }

    configOptions = () => {
        const { data, businessList } = this.props;
        const { currencyCode, jdeApplySceneId, lineOfBusiness, isRealitySettle,isMsaSpecialContractReduce,isMsaSpecialDiscountCustom,isDiscountTermValidity,contractOrLetterIsSignShow} = data;
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        const showSecondLine = (secondLineList || []).length > 0;
        const showRealitySettle = contractOrLetterIsSignShow=='是';
        let options = [];
        if (jdeApplySceneId === 1) {
            options.push({
                name: '系统中是否有此项目',
                key: 'jdeApplyIsInvestigationExistsShow',
            }, {
                name: '此项目是否为临床项目',
                key: 'isClinicalProjectShow',
            }, {
                name: '合同或函证是否签署',
                key: 'contractOrLetterIsSignShow',
            }, {
                name: '合同性质',
                key: 'natureOfContractShow',
            }, {
                // CRM推送数据(JDE建号申请-临床评估关联记录)，仅CRM关联的申请单有值
                name: '业务机会编号',
                key: 'businessOpportunityNum',
            }, {
                name: '临床评估单号',
                key: 'evaluateCode',
            },
            // {
            //     name: '申办方',
            //     key: 'sponsorName',
            // }, 
            {
                name: '合同签署方',
                key: 'contractSignCompanyName',
            },
            {
                name: '项目识别码',
                key: 'investigationIdentifyCode',
            }, 
            {
                name: '项目编号',
                key: 'customerProjectCode',
            }, {
                name: '客户全名',
                key: 'customerCompanyName',
            }, {
                name: '客户JDE号',
                key: 'customerJdeCode',
            }, {
                name: 'BA',
                key: 'ba',
            }, {
                name: '研究产品类型',
                key: 'researchProductTypeShow',
            }, {
                name: '项目分期',
                key: 'investigationByStageName',
                remark: 'investigationByStageRemark',
            }, {
                name: '疾病',
                key: 'diseaseName',
            }, {
                name: '疾病分类',
                key: 'diseaseClassName',
            }, {
                name: '项目领域',
                key: 'investigationAreaName',
            }, {
                name: '受试者类型',
                key: 'testeeTypeName',
            }, {
                name: '业务线',
                key: 'lineOfBusinessString',
            });
            if (showSecondLine) {
                options.push({
                    name: '执行业务线二级分类',
                    key: 'secondLineNames'
                });
            }
            options.push({
                name: '项目分类',
                key: 'investigationTypeName',
            },
            // 手动创建项目时，JDE建号申请信息不再展示合同关联中心，用null占位保持两列对齐
            null, {
                name: '合同签署单位',
                key: 'signingUnit',
            }, {
                name: '收入归属单位',
                key: 'belongingToUnit',
            }, {
                name: '币种', 
                key: 'currency',
            }, {
                name: '汇率',
                key: 'exchangeRate',
            });
            if (currencyCode === 'CNY') {
                options.push({
                    name: '预计合同金额/人民币',
                    key: 'expectContractAmount',
                    unit: '元',
                }, {
                    name: '备注',
                    key: 'contractRelationSiteComment',
                });
            } else {
                if (showSecondLine) {
                    options.push(null);
                }
                options.push(null);
                options.push({
                    name: '预计合同金额/人民币',
                    type: 'function',
                    func: this.getExpectContractAmountDom, 
                }, null, {
                    name: '备注',
                    key: 'contractRelationSiteComment',
                });
            }
        } else if (jdeApplySceneId === 2) {
            options.push({
                name: '系统中是否有此项目',
                key: 'jdeApplyIsInvestigationExistsShow',
            }, {
                name: '此项目是否为临床项目',
                key: 'isClinicalProjectShow',
            }, {
                name: '合同或函证是否签署',
                key: 'contractOrLetterIsSignShow',
            }, {
                name: '合同性质',
                key: 'natureOfContractShow',
            }, {
                // CRM推送数据(JDE建号申请-临床评估关联记录)，仅CRM关联的申请单有值
                name: '业务机会编号',
                key: 'businessOpportunityNum',
            }, {
                name: '临床评估单号',
                key: 'evaluateCode',
            },
            // {
            //     name: '申办方',
            //     key: 'sponsorName',
            // },
            {
                name: '合同签署方',
                key: 'contractSignCompanyName',
            },
            {
                name: '项目识别码',
                key: 'investigationIdentifyCode',
            }, {
                name: '项目编号',
                key: 'customerProjectCode',
            }, {
                name: '客户全名',
                key: 'customerCompanyName',
            }, {
                name: '客户JDE号',
                key: 'customerJdeCode',
            }, {
                name: 'BA',
                key: 'ba',
            }, {
                name: '疾病',
                key: 'diseaseName',
            }, {
                name: '疾病分类',
                key: 'diseaseClassName',
            }, {
                name: '项目领域',
                key: 'investigationAreaName',
            }, {
                name: '受试者类型',
                key: 'testeeTypeName',
            }, {
                name: '业务线',
                key: 'lineOfBusinessString',
            });
            if (showSecondLine) {
                options.push({
                    name: '执行业务线二级分类',
                    key: 'secondLineNames'
                });
            }
            options.push({
                name: '项目分类',
                key: 'investigationTypeName',
            }, {
                name: '合同签署单位',
                key: 'signingUnit',
            }, {
                name: '收入归属单位',
                key: 'belongingToUnit',
            }, {
                name: '合同中是否明标合同金额',
                key: 'contractIsSpecifiesAmountShow',
            }, {
                name: '币种', 
                key: 'currency',
            }, {
                name: '汇率',
                key: 'exchangeRate',
            });
            if (currencyCode === 'CNY') {
                options.push({
                    name: '合同额含税/人民币',
                    key: 'contractAmount',
                    unit: '元',
                }, {
                    name: '合同税率',
                    key: 'rate',
                    unit: '%',
                });
            }
            if (showSecondLine) {
                options.push(null);
            }
            options.push({
                name: '其中需扣除',
                type: 'function',
                func: this.getContractDom, 
            }, null)
            if(showRealitySettle){
                options.push(
                    {
                        name: '是否据实结算',
                        key: 'realitySettleShow',
                    }
                )
                if(isRealitySettle==0 && isMsaSpecialDiscountCustom==1 && isDiscountTermValidity==1){
                    options.push({
                        name: <span>MSA特殊优惠是否从&nbsp;&nbsp;<br />合同额中扣减</span>,
                        key: 'msaSpecialContractReduceShow',
                    })
                    if( isMsaSpecialContractReduce==1){
                        options.push({
                            name: <span>优惠金额（含税）&nbsp;&nbsp;<br />/人民币</span>,
                            key: 'discountContractAmount',
                            unit: '元',
                        },{
                            name: <span>优惠金额（不含税）&nbsp;&nbsp;<br />/人民币</span>,
                            key: 'discountContractAmountNoTax',
                            unit: '元',
                        })
                    }
                }else{
                    options.push(null)
                }
            }
            options.push(
            {
                name: '合同开始时间',
                key: 'contractStartDateShow',
            }, {
                name: '合同结束时间',
                key: 'contractEndDateShow',
            },  {
                name: '是否拥有纸质合同',
                key: 'havePaperContractShow',
            }, {
                name: '备注',
                key: 'contractRelationSiteComment',
                props: { style: { width: 540 } },
            }, null, {
                name: '合同附件',
                type: 'callback',
                func: this.getFileList,
                props: { style: { width: 540 } },
            });
        }
        this.setState({ options });
        this.loadFileList();
    }

    loadFileList = () => {
        const { data: { jdeApplyId } } = this.props;
        const options = {
            method: 'post',
            url: API_URL.contract.queryJdeApplyFileMetaById,
            data: {
                jdeApplyId,
                uploadType: 'CONTRACT',
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.data;
                fileList.forEach((item, index) => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = index;
                });
                this.setState({ fileList });
            }
        };
        $.sendRequest(options);
    }

    getDom = (option) => {
        if (!option) {
            return null;
        }
        const { data } = this.props;
        const { baName, baCode } = data;
        const { name, key, unit, type, func, remark, props = {} } = option;
        return (
            <div className="item">
                <label className="ui-label">{name}</label>
                <span className="ui-text" {...props}>
                    {
                        key && (
                            key === 'ba' ?
                                format('joint', baName, baCode)
                            :
                                (
                                    unit === '元' ?
                                        `${format('money', data[key])}  元`
                                    :
                                        unit === '%' ?
                                            format('unit', data[key], '%')
                                        :
                                            remark ?
                                                data[remark] ? `${data[key]}(${data[remark]})` : data[key]
                                            :
                                                data[key]
                                )
                        )
                    }
                    { type === 'callback' && func() }
                </span>
            </div>
        )
    }
    
    getContractDom = () => {
        const { data } = this.props;
        const {
            currencyCode,
            exchangeRate,
            currencyName,
            rate,
            initialContractAmount,
            initialActualExpenseFee,
            initialActualFee,
            initialTaxationFee,
        } = data || {}
        const options = [{
            name: '实报实销(不含税)/人民币',
            key: 'actualExpenseFee',
            unit: '元',
        }, {
            name: '实报实销税费/人民币',
            key: 'actualFee',
            unit: '元',
        }, {
            name: '合同额税费/人民币',
            key: 'taxationFee',
            unit: '元',
        }];
        const htmlStr = (currencyCode === 'CNY') ?
            <div className="FeeBackground" style={{ width: '90%', marginLeft: 20 }}>
                <div style={{position:'absolute',top:0,left:0,right:'80%',bottom:0,background:'#f9f9f9',borderRight:"1px solid #ccc"}}>
                    <span style={{position:"absolute",left:"46px",top:"50%",transform:'translateY(-50%)'}}>&nbsp;其中<br/>需扣除</span>
                </div>
                <div style={{height:"100%",marginLeft:'20%'}}>
                    {
                        options.map(item => (
                            <li key={item.key} className='preview-item' style={{background: '#f9f9f9' }}>
                                {this.getDom(item)}
                            </li>
                        ))
                    }
                </div>
            </div>
            :
            <div className="jde-rate">
                <div>
                    <div className="left" style={{ width:'55%'}}>
                        <div className="left lable" style={{width:'59.4%'}}>合同额含税/原币</div>
                        <div className="right text-com" style={{width:'40.6%'}}>
                            {format('money', initialContractAmount)}&nbsp;{currencyName}
                        </div>
                    </div>
                    <div className="right" style={{ width:'45%'}}>
                        <div className="left lable" style={{width:'50%'}}>合同额含税/人民币</div>
                        <div className="right text-com" style={{width:'50%'}}>
                            {format('money', initialContractAmount, exchangeRate)}&nbsp;元
                        </div>
                    </div>
                </div>
                <div className="jde-top">
                    <div className="left lable" style={{width:'10%',textAlign:'center',borderRight:0}}>其中<br/>需扣除</div>
                    <div className="right jde-left" style={{width:'90%'}}>
                        <div>
                            <div className="left" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/原币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialActualExpenseFee)}&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>实报实销(不含税)/人民币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialActualExpenseFee, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                        <div className="jde-bottom">
                            <div  className="left" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>实报实销税费/原币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialActualFee)}&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>实报实销税费/人民币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialActualFee, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                        <div className="jde-bottom">
                            <div className="left" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>合同额税费/原币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialTaxationFee)}&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width:'50%'}}>
                                <div className="left lable" style={{width:'50%'}}>合同额税费/人民币</div>
                                <div className="right text-com" style={{width:'50%'}}>
                                    {format('money', initialTaxationFee, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="jde-top">
                    <div className="left lable" style={{width:'32.6%'}}>合同税率</div>
                    <div className="right text-com" style={{width:'67.4%'}}>{rate}%</div>
                </div>
            </div>
        return htmlStr;
    }
    
    getExpectContractAmountDom = () => {
        const { data } = this.props;
        const { currencyCode, currencyName, expectContractAmount, initialExpectContractAmount, exchangeRate } = data || {}
        const htmlStr = (currencyCode == 'CNY') ?
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">预计合同金额/人民币</label>
                    <span className="ui-text">
                        {format('money', expectContractAmount)}&nbsp;元
                    </span>
                </div>
            </li>
            :
            <div className="jde-rate">
                <div className="left" style={{ width:'50%'}}>
                    <div className="left lable" style={{width:'50%'}}>预计合同金额/原币</div>
                    <div className="right text-com" style={{width:'50%'}}>
                        {format('money', initialExpectContractAmount)}&nbsp;{currencyName}
                    </div>
                </div>
                <div className="right" style={{ width:'50%'}}>
                    <div className="left lable" style={{width:'50%'}}>预计合同金额/人民币</div>
                    <div className="right text-com" style={{width:'50%'}}>
                        {format('money', initialExpectContractAmount, exchangeRate)}&nbsp;元
                    </div>
                </div>
            </div>
       return htmlStr;
    }
    
    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }
    
    getFileList = () => {
        const { fileList } = this.state;
        return fileList.map(i => <a onClick={e => this.downLoadFile(e, i.response.fileMetaId)}>{i.name}<br /></a>);
    }

    render() {
        const { options } = this.state;
        const result = [];
        // 将数组成对创建成react-element
        for (let i = 0, len = options.length; i < len; i++) {
            if (options[i] && options[i].type === 'function') {
                result.push(options[i].func());
            } else if (Math.floor(i / 2) === Math.floor((i + 1) / 2)) {
                result.push(
                    <li key={i} className='preview-item'>
                        {this.getDom(options[i])}
                        {this.getDom(options[i + 1])}
                    </li>
                );
                i++;
            }
        }
        
        return (
            <ul className="preview-list deliver-code nobg">
                {result}
            </ul>
        );
    }
}

export default ApplyJdeCodeInfo;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/ApplyJdeCodeInfo.js